<template lang="pug">
v-menu(
  v-model="show"
  rounded="lg"
  allow-overflow
  :close-on-content-click="false"
  content-class="border-dropdown"
  max-height=345
)
  template(v-slot:activator="{on, attrs}")
    v-sheet.text-xs.round-lg(
      v-bind="attrs"
      v-on="on"
      flat
      outlined
      height=40
      min-width=240
    )
      .d-flex.align-center.fill-height.px-4
        .flex-grow-1.capitalize(v-if="selectedField") {{ selectedField.field_name }}
        .flex-grow-1.capitalize.neutral500--text(v-else) Unmapped
        v-icon(size=16) $yzi-chevron-down
  .text-xs.white
    .sticky.top-0.white
      .d-flex.align-center.fill-height.px-4.py-3
        .flex-grow-1.capitalize(v-if="selectedField") {{ selectedField.field_name }}
        .flex-grow-1.capitalize.neutral500--text(v-else) Unmapped
        v-icon(@click="show = false" size=16) $yzi-chevron-down
      v-divider
      v-text-field.my-2.mx-4.text-xs.round-lg(
        v-model="fieldName"
        outlined 
        placeholder="Search or add new" 
        dense
        hide-details
      )
      v-divider
      template(v-if="shouldShowCreateButton")
        .px-4.py-3
          a.info--text.font-semibold(@click="createField") Create field "{{ fieldName }}"
        v-divider
    .px-4.py-3.font-semibold Existing field
    v-divider
    div(v-for="field in filteredFields")
      .d-flex.px-4.py-3(v-if="isFieldDisabled(field)")
        .text-capitalize.flex-grow-1.basic500--text {{ field.field_name }}
        .text-capitalize.text-xs.basic500--text Mapped
      .d-flex.px-4.py-3.clickable.hover-bg(v-else @click="selectField(field)")
        .text-capitalize.flex-grow-1 {{ field.field_name }}
        .text-capitalize.text-xs.basic600--text {{ field.type }}
      v-divider
    template(v-if="!filteredFields.length")
      .px-4.py-3 No results match
      v-divider
  y-dialog(
    v-if="showNewFieldDialog"
    v-model="showNewFieldDialog"
    max-width=568
    content-class="round-2xl"
    fluid
    scrollable
    persistent
  )
    v-card
      v-card-title.px-4
        v-spacer
        h6.ml-10 Create new field
        v-spacer
        v-btn(icon @click="showNewFieldDialog = false")
          v-icon mdi-close
      v-divider
      v-card-text.pa-6.primary--text
        .text-md.mb-6 This field will be saved and added to your customer database column. Confirm field name and choose data type.
        .font-semibold.mb-2 Field name
        v-text-field.round-2xl.border-input.mb-4(
          v-model="fieldName"
          solo 
          flat 
          hide-details
          height=56
        )
        .font-semibold.mb-2 Data type
        v-select.round-2xl.border-input(
          v-model="selectedType"
          placeholder="Choose data type"
          :items="types"
          item-text="text"
          item-value="value"
          solo
          flat
          hide-details
          :menu-props="{ bottom: true, offsetY: true }"
          full-width
        )
          template(v-slot:append)
            v-icon $yzi-chevron-down
          template(v-slot:item="{item}")
            .text-sm {{ item.text }}
          template(v-slot:selection="{item}")
            .text-sm {{ item.text }}
      v-divider
      v-card-actions.px-6.py-3
        v-spacer
        v-btn.button-Aa-large.px-6.neutral500--text.round-lg(
          @click="showNewFieldDialog = false" 
          text 
          height=48
        ) {{ $t('cancel') }}
        v-btn.button-Aa-large.px-6.round-lg(
          @click="confirmNewField"
          :loading="isLoading"
          :disabled="!selectedType || !fieldName.length"
          color="info"
          depressed
          height=48
        ) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CustomFieldDropdown',
  props: ['field', 'selectedFields'],
  data: () => ({
    fieldName: '',
    selectedType: null,
    show: false,
    showNewFieldDialog: false,
    types: [
      {
        text: 'Regular text',
        value: 'string'
      },
      {
        text: 'Number',
        value: 'number'
      },
      {
        text: 'Date',
        value: 'date'
      }
    ],
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      existingFields: 'customers/getFields'
    }),
    shouldShowCreateButton() {
      let containExactField = false
      this.existingFields.map(item => {
        if (item.field_name.toLowerCase() === this.fieldName.toLowerCase()) {
          containExactField = true
        }
      })
      return this.fieldName.length && !containExactField
    },
    filteredFields() {
      const keyword = this.fieldName.toLowerCase()
      const items = [...this.existingFields]
      return items.filter(item => (item.field_name.toLowerCase().includes(keyword) || item.field_name.toLowerCase().includes(keyword)))
    },
    selectedField: {
      get() {
        return this.field
      },
      set(newValue) {
        this.$emit('update:field', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    createField() {
      this.showNewFieldDialog = true
    },
    selectField(field) {
      this.selectedField = field
      this.show = false
      this.fieldName = ''
    },
    confirmNewField() {
      const unavailable = this.existingFields.filter(item => item.field_name === this.fieldName).length > 0
      if (unavailable) {
        this.showMessage(['error', 'Field name is unavailable.'])
        return
      }
      this.isLoading = true
      const params = {
        field_name: this.fieldName.toLowerCase(),
        datatype: this.selectedType,
      }
      this.$axios.post(`/connect/${this.company.slug}/customer_custom_fields`, params)
      .then(resp => {
        const field = resp.data
        this.$store.commit('customers/setNewField', field)
        this.selectField(field)
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    isFieldDisabled(field) {
      return this.selectedFields.filter(i => i === `${field.id}`).length
    }
  }
}
</script>